<template>
  <div class="cert-list-empty">
    <img
      class="cert-list-empty-img"
      src="@/assets/images/profile/empty-state-plans.png"
    />
    <h6 class="dashboard__tab-title cert-list-empty__title">
      You don’t have an active subscription.
    </h6>
    <p class="cert-list-empty__info">
      With plans crafted to fit any need from beginner to enterprise, we've got
      you covered. Access our beginner courses or our whole library. Get started
      today.
    </p>
    <div class="cert-list-empty__btn-wrapper">
      <a :href="`//${plansLink}`" target="_blank" class="btn btn--primary"
        >Browse plans</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoPlans',
  props: {
    plansLink: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.no-plans {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: var(--white);
  text-align: center;
  @include desktop {
    max-width: 900px;
  }
  &__title {
    text-align: center;
    margin: 0 0 10px 0 !important;
  }
  &__info {
    text-align: center;
    font-size: rem(16);
    line-height: 24px;
    color: var(--light-blue-gray);
  }
  &__btn-wrapper {
    margin: 10px auto 0 auto;
  }
  &-img {
    width: 100%;
    max-height: 315px;
    object-fit: contain;
    @include tablet {
      width: unset;
    }
  }
}
</style>
